<template>
    <v-dialog ref="dialog" v-model="modal" width="290px">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="formattedDate"
                :label="$t('filters.labels.monthYear')"
                readonly
                v-bind="attrs"
                v-on="on"
                v-on:append="on"
                clearable
                append-icon="mdi-calendar"
                @click:append="modal = true"
            >
            </v-text-field>
        </template>
        <v-date-picker
            v-model="model"
            type="month"
            @input="modal = false"
            scrollable
        />
    </v-dialog>
</template>

<script>
export default {
    props: ['name', 'resource'],

    data: () => ({
        modal: false,
    }),

    computed: {
        key() {
            return [this.resource, this.name].join('.')
        },
        model: {
            get() {
                return this.$store.getters['filters/getByDotNotation'](this.key)
            },
            set(value) {
                this.$store.commit('filters/apply', {
                    resource: this.resource,
                    filter: { name: this.name, value: value },
                })
            },
        },

        formattedDate: {
            get() {
                if (this.model) {
                    const formattedDate = this.model.split('-')
                    return formattedDate[1] + '/' + formattedDate[0]
                }

                return null
            },
            set(value) {
                if (value == null) {
                    this.model = null
                }
            },
        },
    },
}
</script>

<style></style>
